import { cn } from '@/lib/utils';

/**
 * The Cmd+K palette: a 20px soft panel, rows and headings inset 8px so radii
 * stay concentric.
 */
export const COMMAND_MENU_CONTENT_CLASS_NAME = cn(
  // Soft, like the home composer it opens over: the composer's surface tone
  // with no hairline outline, lifted by the menus' soft wide drop
  // (Raj, 2026-11-02: the palette still had the old outlined card).
  'text-popover-foreground !z-[10003] top-[16%] max-w-[calc(100%-1.5rem)] translate-y-0 gap-0 rounded-[20px] border-0 bg-[var(--soft-control-surface)] shadow-popover sm:top-[18%] sm:max-w-[640px]',
  // The shared dialog fade + scale (`imai-dialog-motion`, instant under
  // reduced motion), anchored at the top so it grows downward.
  'origin-top'
);

/** A light scrim: the palette floats over the page rather than replacing it. */
export const COMMAND_MENU_OVERLAY_CLASS_NAME =
  '!z-[10003] bg-black/15 dark:bg-black/40';

/** Overrides for the cmdk root that `CommandDialog` sizes for shadcn. */
export const COMMAND_MENU_COMMAND_CLASS_NAME =
  'rounded-none bg-transparent **:data-[slot=command-input-wrapper]:h-11 [&_[cmdk-group]]:px-2 [&_[cmdk-group-heading]]:px-2.5 [&_[cmdk-group-heading]]:text-muted-foreground [&_[cmdk-input]]:h-11 [&_[cmdk-item]]:px-2.5 [&_[cmdk-item]]:py-1.5';

/**
 * The search field is an inset 12px-radius well sitting 8px inside the 20px
 * shell (concentric), like the skills panel's search. Its fill is a step
 * quieter than the selected row's wash so the two never read as one bar;
 * the raised soft ring keeps its edge. No full-bleed divider:
 * the inset spacing separates it from the list. 16px of inner padding puts
 * the icon on the same axis as the 28px row tiles, and the 18px gap starts
 * the text where row titles start.
 */
export const COMMAND_MENU_INPUT_WRAPPER_CLASS_NAME =
  'bg-foreground/[0.025] dark:bg-foreground/[0.04] shadow-[var(--soft-control-raised-shadow)] mx-2 mt-2 h-11 shrink-0 gap-[18px] rounded-[12px] border-0 pe-3 ps-4 [&>svg]:text-muted-foreground [&>svg]:opacity-100';

/** Field text and placeholder match the row titles from md up. */
export const COMMAND_MENU_INPUT_CLASS_NAME =
  'placeholder:text-muted-foreground h-11 text-base/6 md:text-sm/6';
